import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { estiloMarcadorRojo } from './configuracion';
import datos from '../json/datos3857.json';

const searchInput = document.getElementById('search-input');
searchInput.addEventListener('input', buscar);
let marker = null;

function buscar() {
    const searchTerm = searchInput.value.toLowerCase();
    const resultsContainer = document.getElementById('results-container');

    resultsContainer.innerHTML = '';

    if (searchTerm.trim() === ''){
        return;
    }

    const resultadosFiltrados = datos.filter(item => item.lugar.toLowerCase().includes(searchTerm));

    resultadosFiltrados.forEach(item =>{
        const resultItem = document.createElement('div');
        resultItem.classList.add('result-item');
        if(item.buscar != null)
            resultItem.textContent = item.lugar + ' - ' + item.obs;
        else resultItem.textContent = item.lugar

        resultItem.addEventListener('click', () => {   
            
            const coordenadas = [item.x, item.y];
            if (marker) {
                global.mapa.removeLayer(marker);
            }
        
            marker = new VectorLayer({
                source: new VectorSource({
                    features: [
                        new Feature({
                            geometry: new Point(coordenadas),
                        })
                    ]
                }),
                style: estiloMarcadorRojo,
            });
            
        
            global.mapa.addLayer(marker);            
            global.vista.animate({
                center: coordenadas,
                duration: 1000
            });
        });
        resultsContainer.appendChild(resultItem);
    });

    if (resultadosFiltrados.length === 0) {
        resultsContainer.innerHTML = '<div class="result-item">No se encontraron resultados</div>';
    }
}